const init_as_module = require('./browsee-core');

var browsee = init_as_module();

module.exports = browsee;
